import {
  EventRecurrenceFreqEnum,
  EventRecurrencePattern
} from 'front-end/src/graphql/private/PrivateSchemaTypes'
import { Trans } from '@lingui/macro'
import { NbSp } from 'front-end/src/utils/NbSp'
import React from 'react'
import { getRecurrenceFreqByValue } from 'front-end/src/pages/manage-events/event-edit/tabs/event-detail/EventRecurrenceModal'
import { getDayFullNames } from 'front-end/src/pages/manage-events/eventUtils'

export const RecurrenceText = ({
  recurrence
}: {
  recurrence: EventRecurrencePattern
}) => {
  const accessor =
    recurrence?.interval && recurrence.interval > 1 ? 'labelPlural' : 'label'

  return (
    <Trans>
      Repeats
      <NbSp />
      {recurrence.byDay && recurrence.freq === EventRecurrenceFreqEnum.WEEKLY
        ? `${getDayFullNames(recurrence.byDay)?.join(', ')} `
        : null}
      every
      {recurrence?.interval && recurrence.interval > 1
        ? ` ${recurrence.interval}`
        : null}
      <NbSp />
      {recurrence.freq && getRecurrenceFreqByValue(recurrence.freq)?.[accessor]}
    </Trans>
  )
}
